export enum CompanyAgreement {
  ServiceSummary = 'service_summary',
  TermsAndConditions = 'terms_and_conditions',
}

export const CompanyAgreementMap = {
  [CompanyAgreement.ServiceSummary]: {
    link: 'https://storage.googleapis.com/res-carrick/onboarding/MaverickX%20Service%20Summary.pdf',
    title: 'Service Summary',
  },
  [CompanyAgreement.TermsAndConditions]: {
    link: 'https://storage.googleapis.com/res-carrick/onboarding/MaverickX%20T%26Cs.pdf',
    title: 'Terms and Conditions',
  },
};

export enum TWhatAccountExist {
  CARRIC_DB,
  AOS_DB,
}

export enum UserConnectionType {
  Social = 'social',
  UsernamePassword = 'username-password',
}

export enum ClientType {
  Brand = 'brand',
  Creator = 'creator',
}
